export const H001 =
  "This is a list of all your accounts, they might store ETH or and GRG tokens.<br>  If you don't see your account(s), make sure you are logged in via Metamask"
